import { render, staticRenderFns } from "./whyChoose.vue?vue&type=template&id=139020ac&scoped=true&"
var script = {}
import style0 from "./whyChoose.vue?vue&type=style&index=0&id=139020ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139020ac",
  null
  
)

export default component.exports